// extracted by mini-css-extract-plugin
module.exports = {"finish":"CourseProgress_finish__FHdgg","total":"CourseProgress_total__2mT5d","inProcess":"CourseProgress_inProcess__fOyEy","waiting":"CourseProgress_waiting__3-Pr-"};